import React from "react";

const Loader = ({
    fullScreen = false,
    text = "Loading..."
}) => {

    if (fullScreen) {

        return (

            <div
                className="d-flex justify-content-center align-items-center"
                style={{
                    height: "100vh",
                    width: "100%",
                    background: "#f8f9fa"
                }}
            >

                <div className="text-center">

                    <div
                        className="spinner-border text-primary"
                        role="status"
                        style={{
                            width: "4rem",
                            height: "4rem"
                        }}
                    >
                        <span className="visually-hidden">
                            Loading...
                        </span>
                    </div>

                    <h5 className="mt-3">
                        {text}
                    </h5>

                </div>

            </div>

        );

    }

    return (

        <div className="text-center py-5">

            <div
                className="spinner-border text-primary"
                role="status"
            >
                <span className="visually-hidden">
                    Loading...
                </span>
            </div>

            <div className="mt-3">

                <strong>{text}</strong>

            </div>

        </div>

    );

};

export default Loader;